import { render, staticRenderFns } from "./MarkAsCompleteModal.vue?vue&type=template&id=0b61e90b"
import script from "./MarkAsCompleteModal.vue?vue&type=script&lang=js"
export * from "./MarkAsCompleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports